<template>
  <div>
    <el-row class="cs-contentContainer">
      <el-col :span="4" class="cs-main-left-container">
        <navigator ref="navMenu"></navigator>
      </el-col>
      <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
        <div class="cs-fullHeight cs-contentContainer-right">
          <div class="backgroud-white  cs-contentContainer-right-content cs-fullHeight">
            <div class="cs-appointmentList-top">
              <span class="cs-title">{{ title }}
                <el-button v-if="!USERMANAGER.isStudent" type="primary" @click="onViewCalendar">查看日程表</el-button>
                &nbsp;&nbsp;
                <!-- <el-button v-if="!USERMANAGER.isStudent" type="primary" @click="onCheckVideo">检查视频文件</el-button> -->
              </span>
            </div>
            <div v-if="!USERMANAGER.isStudent && !showAddAppointmentPage">
              <el-tabs v-model="activeCampusId" type="card" @tab-click="onTabClicked">
                <el-tab-pane :key="item.Id" v-for="item in campusList" :name="item.Id.toString()">
                  <span slot="label">
                    {{ item.Name }}
                    <span
                      v-if="!USERMANAGER.isStudent && !!pendingAppointmentCountWithCampus && pendingAppointmentCountWithCampus[item.Id]"
                      class="cs-pendingVACount">
                      <span> {{ pendingAppointmentCountWithCampus[item.Id] }}</span>
                    </span>
                  </span>
                  <appointmentList ref="appointmentList" :isActive="activeCampusId == item.Id.toString()" :campusId="item.Id" @customEvent="customEventHandler"
                    @reload="onReload"></appointmentList>
                </el-tab-pane>
              </el-tabs>
            </div>

            <div>
              <div v-if="USERMANAGER.isStudent && !showAddAppointmentPage">
                <el-button v-if="USERMANAGER.isStudent" class="add-appointment-btn" type="primary" plain
                  icon="el-icon-plus" @click="addAppointment">添加预约</el-button><br>
                <el-row class="grid-content appointment.content">
                  <el-col>
                    <appointmentList @customEvent="customEventHandler" :isActive="true"></appointmentList>
                  </el-col>
                </el-row>
              </div>


              <div v-if="showAddAppointmentPage">
                <el-button type="text" @click="goBack">返回</el-button>
                <avappWorkflowMain @close="onCloseWorkflow" :id="appointmentId" :isPayment="isPayment">
                </avappWorkflowMain>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog v-if="videoCheckingVisible" title="检查视频文件" :center="true" :close-on-click-modal="false" width="600px"
      :visible.sync="videoCheckingVisible" top="3vh">
      <avappVideoCheckingList></avappVideoCheckingList>
    </el-dialog>
    <el-dialog v-if="calendarVisible" title="日程表" :center="true" :close-on-click-modal="true" width="90%"
      :visible.sync="calendarVisible" top="3vh">
      <avappCalendar class="cs-calendarDialog" :isView="true" :dataIn="calendarData"></avappCalendar>
    </el-dialog>

  </div>
</template>

<style lang="scss">
.cs-appointmentList-top {

  .el-button {
    float: right;
    margin-left: 20px;
  }
}

.cs-calendarDialog {
  padding: 0 30px;
}
</style>

<script>
import navigator from "../components/navigator";
import appointmentList from "../components/addVideoAppointment/appointmentList";
import avappWorkflowMain from "../components/addVideoAppointment/avappWorkflowMain";
import avappVideoCheckingList from "../components/addVideoAppointment/avappVideoCheckingList";
import avappCalendar from "../components/addVideoAppointment/avappWorkflowStep2";

import global_ from "../core/global";
import { formatDate } from "../config/mUtils";
import { getCampusList } from "../service/common.service";
import { getPendingVideoAppointmentCountWithCampus } from "../service/videoAppointment.service";

export default {
  data() {
    return {
      loading: false,
      showAddAppointmentPage: false,
      activeCampusId: "",
      campusListData: [],
      appointmentId: 0,
      isPayment: false,
      title: "视频预约",
      campusList: [],
      videoCheckingVisible: false,
      calendarVisible: false,
      pendingAppointmentCountWithCampus: {},
      calendarData: {

      }
    }
  },
  async created() {
    if (!this.USERMANAGER.isStudent) {
      this.title = "预约列表";
    }
    this.initData();
  },
  components: {
    navigator,
    appointmentList,
    avappWorkflowMain,
    avappVideoCheckingList,
    avappCalendar
  },
  methods: {
    loadPendingAppointmentCountWithCampus() {
      getPendingVideoAppointmentCountWithCampus().then(result => {
        if (!!result && result.success) {
          this.pendingAppointmentCountWithCampus = result.data;
        }
      });

    },
    getPendingVideoAppointmentCount(campusId) {
      if (!!this.pendingAppointmentCountWithCampus && !!this.pendingAppointmentCountWithCampus[campusId]) {
        return this.pendingAppointmentCountWithCampus[campusId];
      }
      return 0;
    },
    onReload() {
      this.loadPendingAppointmentCountWithCampus();
      this.$refs.navMenu.loadPendingVideoAppointmentCount();
    },
    initData() {
      this.loadPendingAppointmentCountWithCampus();
      getCampusList().then(result => {
        if (!!result && result.success) {
          this.campusList = result.data;
          this.activeCampusId = this.campusList[0].Id.toString();
        }
      });
    },
    addAppointment() {
      this.isPayment = false;
      this.appointmentId = 0;

      this.showAddAppointmentPage = true;
    },
    onViewCalendar() {
      this.calendarVisible = true;
    },
    onTabClicked() {

    },
    edit() {

    },
    goBack() {
      this.showAddAppointmentPage = false;
    },
    onCloseWorkflow() {
      this.showAddAppointmentPage = false;

    },
    customEventHandler(data) {
      if (data.name == "continue" || data.name == "pay") {
        if (data.name == "pay") {
          this.isPayment = true;
        } else {
          this.isPayment = false;
        }
        this.appointmentId = data.id;
        this.showAddAppointmentPage = true;
      }
    },

    onCheckVideo() {
      this.videoCheckingVisible = true;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/videoAppointmentList.vue